import React, { Component } from 'react'
import styles from '../../assets/styles/components/WaiterLogin'
import injectSheet from 'react-jss'
import cx from 'classnames'
import logoImage from '../../assets/images/logo.png'

class WaiterLogin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      merchantAccount: window.localStorage.getItem('waiter-merchantUsername') || '',
      account: window.localStorage.getItem('waiter-username') || '',
      password: '',

      loading: false,
    }
  }

  componentDidMount = async () => {
  }

  async handleSubmit (e) {
    e.preventDefault()

    const {
      merchantAccount,
      account,
      password,
    } = this.state

    const {
      loginWaiter,
      linkMerchant,
    } = this.props

    if (!merchantAccount || !account || !password) {
      return
    }

    this.setState({
      loading: true,
    })
    await loginWaiter({
      merchantUsername: merchantAccount,
      username: account,
      password: password,
    }).catch(e => {
      alert('登入失敗')
      this.setState({
        loading: false,
      })
    })
    const res = await linkMerchant()
    // login success
  }

  render () {
    const {
      intl,
      classes,
    } = this.props

    const {
      merchantAccount,
      account,
      password,
    } = this.state

    const textMap = {
      merchantAccount: intl.formatMessage({ id: 'merchantAccount' }),
      account: intl.formatMessage({ id: 'account' }),
      password: intl.formatMessage({ id: 'password' }),
      login: intl.formatMessage({ id: 'login' }),
    }

    const styleMap = {
      card: cx(classes.card),
      logoDiv: cx(classes.logoDiv),
      backdrop: cx(classes.backdrop),
      input: cx(classes.input),
      passwordInput: cx(classes.passwordInput),
    }

    let formDisabled = true
    if (merchantAccount && account && password) {
      formDisabled = false
    }

    return (
      <React.Fragment>
        <div className={styleMap.backdrop}> </div>
        <form className={styleMap.card} onSubmit={(e) => { this.handleSubmit(e) }}>
          <div className={styleMap.logoDiv} style={{
            backgroundImage: `url(${logoImage})`,
          }}> </div>
          <div className={cx([classes.inputDiv, classes.merchantAccountDiv])}>
            <input
              value={this.state.merchantAccount}
              onChange={(e) => this.setState({ merchantAccount: e.target.value })}
              className={cx(classes.input, {
                [classes.disabledInput]: this.state.loading,
              })}
              placeholder={textMap.merchantAccount}
              type="text"
            />
          </div>
          <div className={cx([classes.inputDiv])}>
            <input
              value={this.state.account}
              onChange={(e) => this.setState({ account: e.target.value })}
              className={cx(classes.input, {
                [classes.disabledInput]: this.state.loading,
              })}
              placeholder={textMap.account}
              type="text"
            />
          </div>
          <div className={cx([classes.inputDiv])}>
            <input
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              className={cx(classes.input, {
                [classes.disabledInput]: this.state.loading,
              })}
              placeholder={textMap.password}
              type="password"
            />
          </div>
          <div className={cx([classes.inputDiv, classes.loginBtnDiv])}>
            <button
              tabIndex={formDisabled ? '-1' : '0'}
              className={cx(classes.loginBtn,
                {
                  [classes.disabled]: formDisabled,
                },
              )}
              type="submit">
              {
                this.state.loading
                  ? <div className={cx(classes.loading)}></div>
                  : textMap.login
              }
            </button>
          </div>
        </form>
      </React.Fragment>
    )
  }
}

export default injectSheet(styles)(WaiterLogin)



// WEBPACK FOOTER //
// ./src/components/scenes/WaiterLogin.js